export default {
    coupons: {
        zhCN: {
            number_order: '序号',
            coupons_number: '券号',
            coupon_desc: '优惠券描述',
            coupons_amount: '优惠券金额',
            status: '使用状态',
            operator: '操作人',
            action: '操作',
            upload_time: '上传时间',
            template_name: 'Coupon Template.xlsx',
            sales_order: '销售订单',
            err_saleId: '暂无关联使用的销售单',
        },
        enUS: {
            number_order: 'NO.',
            coupons_number: 'Coupons No.',
            coupon_desc: 'Coupon Desc',
            status: 'Status',
            operator: 'Operator',
            coupons_amount: 'Coupons Amount',
            action: 'Action',
            upload_time: 'Upload Time',
            template_name: 'Coupon Template.xlsx',
            sales_order: 'Sales Order',
            err_saleId: 'No associated use of sales orders',
        },
    },
    salesTarget: {
        zhCN: {
            number_order: '序号',
            group: '组',
            dt_group: '组',
            dealer_code: '经销商代码',
            dt_code: '经销商代码',
            customer_code: '客户代码',
            dealer_name: '经销商名称',
            rebate_type: '返利类型',
            related_kpi_policy_name: '相关KPI政策名称',
            kpi_policy_name: '相关KPI政策名称',
            sales_target: '销售目标',
            operator: '操作人',
            action: '操作',
            upload_time: '上传时间',
            time: '时间',
            approvalOpinion: '审批意见',
            approval_status: '审批状态',
            old_sales_target: '旧销售目标',
            new_sales_target: '新销售目标',
            sales_target_edit: '销售目标编辑',
            modifyRemark: '修改意见',
            remark: '拒绝原因',
            please_input_kpi: '请填写相关KPI政策名称',
            bothNone: '经销商代码和组名不能同时为空',
            not_edit: '销售目标不存在，请新增一条',
            batch_pass: '批量通过',
            please_batch: '请先勾选批量审核的销售目标',
            salesTarget: '销售目标',
            group_code: '组号',
            material_code: '物料号',
            parameter_name: '参数名称',
            dtCodeOrdtGroupChooseOne: 'Dt Code或 Dt Group 二选一',
            pay_level: 'Pay Level',
            customer_name: '客户名称',
            bothNoneTargetOrlevel: '销售目标和Pay Level不能同时为空',
            kpi_approval: 'KPI目标审批',
        },
        enUS: {
            number_order: 'No.',
            group: 'Group',
            dt_group: 'DT Group',
            dealer_code: 'Dealer Code',
            dt_code: 'DT Code',
            customer_code: 'Customer Code',
            dealer_name: 'Dealer Name',
            rebate_type: 'Rebate Type',
            related_kpi_policy_name: 'Related KPI Policy Name',
            kpi_policy_name: 'Quarterly Target Name',
            sales_target: 'Sales Target',
            operator: 'Operator',
            action: 'Action',
            upload_time: 'Upload Time',
            time: 'Time',
            approvalOpinion: 'Approval Opinion',
            approval_status: 'Approval Status',
            old_sales_target: 'Original Sales Target',
            new_sales_target: 'New Sales Target',
            sales_target_edit: 'Sales Target Edit',
            modifyRemark: 'Modify Remark',
            remark: 'Reject Remark',
            please_input_kpi: 'Please input policy name with KPI',
            bothNone: 'Group and Dealer Code cannot be empty at the same time',
            not_edit: 'Sales target does not exist,please add it',
            batch_pass: 'Batch Pass',
            please_batch: 'Please check the sales target for batch audit first',
            salesTarget: 'Sales Target',
            group_code: 'Group Code',
            material_code: 'Material Code',
            parameter_name: 'Parameter Name',
            dtCodeOrdtGroupChooseOne: 'group and customer code is a must to fill in',
            pay_level: 'Pay Level',
            customer_name: 'Customer Name',
            bothNoneTargetOrlevel: 'Sales target and pay level cannot be empty at the same time',
            kpi_approval: 'KPI Target Approval',
        },
    },
    nonCompliantDealers: {
        zhCN: {
            number_order: '序号',
            dealer_code: '经销商代码',
            dealer_name: '经销商名称',
            quarter: '季度',
            order_type: '订单类型',
            start_date: '开始时间',
            end_date: '结束时间',
            status: '状态',
            operator: '操作人',
            action: '操作',
            upload_time: '上传时间',
            update_time: '更新时间',
            create_time: '创建时间',
            non_compliant_dealers: '不达标经销商',
            set_types_of_orders_in_rebates: '标准返利订单类型',
            order_type_to_participate: '请选择参与返利的订单类型',
            validity_date: '有效期',
            dealers_choose_more: '可以选择一个或者多个经销商',
            training_margin: '售后',
            stocking_margin: '销售',
            terms: '比例',
            stdMargin: 'Std Margin',
            stdMarginTerm: 'Std Margin Term',
            limit: '请先选择季度',
            all_up_to_standard: '达标显示',
            training_all_up_to_standard: '培训达标',
            stocking_all_up_to_standard: '库存达标',
            upperMargin: '上下限',
            confirm_submit: '确认提交吗',
            pleaseSelectAtLeastOneItem: '请至少选择一项',
            click_pass: '点击"通过"按钮通过所有选定项目',
            comment: '审批意见',
            approval_status: '审批状态',
            submit_person: '提交人',
            submit_time: '提交时间',
            reject_confirm: '请确认提交',
            reasons_for_non_compliance: '不达标原因',
            reason_for_non_compliance_is_required: '不达标原因必填',
            date: '日期',
            after_sales_required: '售后必填',
            sales_required: '销售必填',
            to_confirm: '请确认提交',
            aftersales_reward: '售后奖励',
        },
        enUS: {
            number_order: 'No.',
            dealer_code: 'Dealer Code',
            dealer_name: 'Dealer Name',
            quarter: 'Quarter',
            order_type: 'Order Type',
            start_date: 'Start Date',
            end_date: 'End Date',
            status: 'Status',
            operator: 'Operator',
            action: 'Operation',
            upload_time: 'Upload Time',
            update_time: 'Update Time',
            create_time: 'Create Time',
            non_compliant_dealers: 'Non-compliant dealers',
            set_types_of_orders_in_rebates: 'Set types of orders in rebates',
            order_type_to_participate:
                'Please select the order type to participate in the standard rebate',
            validity_date: 'Validity Date',
            dealers_choose_more: 'Can choose more than one dealers',
            training_margin: 'After-sales',
            stocking_margin: 'Sales',
            terms: 'Terms',
            stdMargin: 'Std Margin',
            stdMarginTerm: 'Std Margin Term',
            limit: 'Please select the quarter first',
            all_up_to_standard: 'Qualified Declaration',
            training_all_up_to_standard: 'After-sales',
            stocking_all_up_to_standard: 'Sales',
            upperMargin: 'upper Margin',
            confirm_submit: 'Do you confirm submission',
            pleaseSelectAtLeastOneItem: 'Please select at least one item',
            click_pass: 'Click ‘Pass’ to pass all of selected items',
            comment: 'Reasons for rejection',
            approval_status: 'Approval Status',
            submit_person: 'Submit Person',
            submit_time: 'Submit Time',
            reject_confirm: 'Please confirm the submission',
            reasons_for_non_compliance: 'Reasons for non-compliance',
            reason_for_non_compliance_is_required: 'Reason for non-compliance is required',
            date: 'Date',
            after_sales_required: 'After-sales is required',
            sales_required: 'Sales is required',
            to_confirm: 'Please confirm the submission',
            aftersales_reward: 'Aftersales Reward',
        },
    },
    rebateList: {
        zhCN: {
            number_order: '序号',
            vin: 'VIN',
            dealer_code: '经销商代码',
            dealer_name: '经销商名称',
            rebate_type: '返利类型',
            model: '车型',
            reg_date: '注册日期',
            reg: '注册号',
            transferred_date: '转让日期',
            action: '操作',
            upload_time: '上传时间',
            santander_sales_order: '桑坦德销售订单',
            vehicle_description: '车辆描述',
            supplier_name: '供应商名称',
            quote_created_date: '报价创建日期',
            vrb_amount: 'VRB金额',
            vat: '税额',
            gross: '总金额',
            related_dcs_sales_order: '相关DCS销售订单',
            rom: '存储器',
            order_no: '订单号',
            order_type: '订单类型',
            price_term: '价格条款',
            receive_time: '发布时间',
            order_date: '订购日期',
            order_status: '订单状态',
            model_version: '型号/版本',
            reg_cancel_date: '注销日期',
            channel: '渠道',
            colour: '颜色',
            payment_type: '付款方式',
            coupons_no: '优惠券编码',
            credit_company: '信贷公司',
            basic_price: '基础价格',
            paint_price: '喷漆费用',
            credit_company_exclusive: '信贷公司专用',
            delivery_price: '运费',
            total_price: '总价',
            mgmfs_invoice: '开票金额',
            currency: '币种',
            asset_cash_price: 'Asset Cash Price (£)',
            original_apr: 'Original APR %',
            original_term: 'Original Term (months)',
            amount_to_finance: 'Amount to Finance (£)',
            fda: 'FDA (£)',
            Subsidy: 'Subsidy (£)',
            product_name: 'Product Name',
        },
        enUS: {
            number_order: 'No.',
            vin: 'VIN',
            dealer_code: 'Dealer Code',
            dealer_name: 'Dealer Name',
            rebate_type: 'Rebate Type',
            model: 'Model',
            reg_date: 'Reg Date',
            reg: 'Reg',
            transferred_date: 'Transferred Date',
            action: 'Action',
            upload_time: 'Upload Time',
            santander_sales_order: 'Creidt Company :  Santander',
            vehicle_description: 'Vehicle Description',
            supplier_name: 'Supplier Name',
            quote_created_date: 'Quote Created Date',
            vrb_amount: 'VRB Amount ',
            vat: 'VAT',
            gross: 'Gross',
            related_dcs_sales_order: 'Related DCS Sales Order',
            rom: 'ROM',
            order_no: 'Order No',
            order_type: 'Order Type',
            price_term: 'Price Term',
            receive_time: 'Receive Time',
            order_date: 'Order Date',
            order_status: 'Order Status',
            model_version: 'Model/Version',
            reg_cancel_date: 'Reg Cancel Date',
            channel: 'Channel',
            colour: 'Colour',
            payment_type: 'Payment Type',
            coupons_no: 'Coupons No',
            credit_company: 'Credit Company',
            basic_price: 'Basic Price',
            paint_price: 'Paint Price',
            credit_company_exclusive: 'Credit Company Exclusive',
            delivery_price: 'Delivery Price',
            total_price: 'Total Price',
            mgmfs_invoice: 'MGMFS Invoice',
            currency: 'Currency',
            asset_cash_price: 'Asset Cash Price (£)',
            original_apr: 'Original APR %',
            original_term: 'Original Term (months)',
            amount_to_finance: 'Amount to Finance (£)',
            fda: 'FDA (£)',
            Subsidy: 'Subsidy (£)',
            product_name: 'Product Name',
            credit_company_sales_order: 'Credit Company Sales Order',
        },
    },
    basicPrice: {
        zhCN: {
            material_code: '物料号',
            vehicle_material_code: '物料号',
            material_description: '物料描述',
            series_code: '车系代码',
            series: '车系',
            gear: '变速箱',
            trim_version: '内饰版本',
            paint: '喷漆',
            basic_price: '基准价格',
            start_date: '开始日期',
            end_date: '结束日期',
            validity_date: '有效期',
            template_name: 'Basic Price Template.xlsx',
            approval_status: '审批状态',
            type: '类型',
            added: '新增',
            edited: '修改',
        },
        enUS: {
            material_code: 'Material Code',
            vehicle_material_code: 'Vehicle Material Code',
            material_description: 'Material Description',
            series_code: 'Series Code',
            series: 'Series',
            gear: 'Gear',
            trim_version: 'Trim Version',
            paint: 'Paint',
            basic_price: 'Basic Price',
            start_date: 'Start Date',
            end_date: 'End Date',
            validity_date: 'Validity Date',
            template_name: 'Basic Price Template.xlsx',
            approval_status: 'Approval Status',
            type: 'Type',
            added: 'Added',
            edited: 'Edited',
        },
    },
    vehicleModelStandard: {
        zhCN: {
            parameter_code: '参数编码',
            parameter_name: '参数名称',
            bonus: 'bonus',
            term: 'term',
            is_valid: '是否有效',
            special_vehicle_type: '特殊车型',
            general_type: 'KPI类型',
            general_code: '通用编号',
            vin: 'VIN',
            code: 'Code',
            model_year: 'Model Year',
            interior_color: 'Interior Color',
            exterior_color: 'Exterior Color',
        },
        enUS: {
            parameter_code: 'Parameter Code',
            parameter_name: 'Parameter Name',
            bonus: 'bonus',
            term: 'term',
            is_valid: 'IsValid',
            special_vehicle_type: 'Special Vehicle Type',
            general_type: 'KPI Type',
            general_code: 'General Code',
            vin: 'VIN',
            code: 'Code',
            model_year: 'Model Year',
            interior_color: 'Interior Color',
            exterior_color: 'Exterior Color',
        },
    },
    salesVolumeSetting: {
        zhCN: {
            parameter_code: '参数编码',
            parameter_name: '参数名称',
            vehicle_model: '车型',
            fixed_sales_volume: '固定销量',
            order_type: '订单类型',
            retail_order_type: '零售订单类型',
        },
        enUS: {
            parameter_code: 'Parameter Code',
            parameter_name: 'Parameter Name',
            vehicle_model: 'Vehicle Model',
            fixed_sales_volume: 'Fixed Sales Volume',
            order_type: 'Order Type',
            retail_order_type: 'Retail Order Type',
        },
    },
    financialCompany: {
        zhCN: {
            financial_company_code: '金融公司编码',
            financial_company_name: '金融公司名称',
        },
        enUS: {
            financial_company_code: 'Financial Company Code',
            financial_company_name: 'Financial Company Name',
        },
    },
    nonCompliance: {
        zhCN: {
            parameter_name: '参数名称',
            start_date: '生效开始日期',
            end_date: '生效截止日期',
            date: '有效日期',
            dt_group: 'DT Group',
            customer: '客户',
            value: 'Value',
            compliance_rate: 'Compliance Rate',
            remark: '备注',
            creator: 'Creator',
            batch_del_msg: '确认批量删除？',
            mutually_exclusive_empty: 'Value 与 Compliance Rate 至少填写一个',
            mutually_exclusive_both: 'Value 与 Compliance Rate 不能同时填写，请只保留一个',
        },
        enUS: {
            parameter_name: 'Parameter Name',
            start_date: 'Validity Start Date',
            end_date: 'Validity End Date',
            date: 'Validity Date',
            dt_group: 'DT Group',
            customer: 'Customer',
            value: 'Value',
            compliance_rate: 'Compliance Rate',
            remark: 'Remark',
            creator: 'Creator',
            batch_del_msg: 'Confirm batch deletion？',
            mutually_exclusive_empty: 'At least one of Value or Compliance Rate must be filled',
            mutually_exclusive_both: 'Value and Compliance Rate cannot be filled at the same time, please keep only one',
        },
    },
    deductionMgmt: {
        zhCN: {
            deduction_no: '抵扣序号',
            deduction_name: '抵扣名称',
            deduction_type: '抵扣类型',
            deduction_amount_excl: 'Amount(Excl. VAT)',
            deduction_amount_incl: 'Amount(incl.VAT)',
            deduction_object: '扣减项目',
            deduction_amount: '扣减金额',
            deduction_reason: '扣减原由',
            vin_list: 'VIN list',
            submission: '提交',
            submission_time: '提交时间',
            batch_del_msg: '确认批量删除？',
            batch_sub_msg: '确认批量提交？',
            vin_type: 'Amount/VIN',
        },
        enUS: {
            deduction_no: 'Deduction No.',
            deduction_name: 'Deduction Name',
            deduction_type: 'Deduction Type',
            deduction_amount_excl: 'Amount(Excl. VAT)',
            deduction_amount_incl: 'Amount(incl.VAT)',
            deduction_object: 'Deduction Object',
            deduction_amount: 'Deduction Amount',
            deduction_reason: 'Deduction Reason',
            vin_list: 'VIN list',
            submission: 'Submission',
            submission_time: 'Submission Time',
            batch_del_msg: 'Confirm batch deletion？',
            batch_sub_msg: 'Confirm batch Submission？',
            vin_type: 'Amount/VIN',
        },
    },
    financialRebate: {
        zhCN: {
            customer_code: '客户代码',
            dealer_code: '经销商代码',
            customer_name: '客户名称',
            customer_type: '客户类型',
            financial_company: '金融公司',
            rebate_type: '返利类型',
            start_inquiry_date: '询价开始日期',
            start_order_date: '订单开始日期',
            vin: 'VIN',
            model: '车型',
            model_details: '详细车型',
            inquiry_date: 'Inquiry Date',
            order_date: 'Order Date(Bank)',
            user_name: '操作者',
            create_time: '创建时间',
            policy_portfolio_name: '政策集名称',
            upload_files: '上传文件',
            remark: '备注',
            financial_company_rebate: '金融公司返利',
            contract_no: '合同单号',
            campaign_name: 'Campaign Name',
            campaign_value: 'Campaign Value',
            delivery_date: 'Delivery Date(Bank)',
            related_order: '关联系统销售订单',
            brand: '品牌',
            cs_date: 'Contract Start Date',
            activation_date: 'Activation Date',
            contract_status: 'Contract Status',
            product: 'Product',
            product_code: 'Product Code',
            number_of_installments: 'Number of Installments',
            effective_interest_rate: 'Effective Interest Rate',
            nominal_interest_rate: 'Nominal Interest Rate',
            vehicle_price: 'Vehicle Price',
            options: 'Options',
            total_price: 'Total Price',
            OEM_discount_percentage: 'OEM Discount Percentage',
            OEM_discount: 'OEM Discount',
            inquiry_no: 'Inquiry Number',
            dealer_number: 'Dealer Number',
            dealer_name: 'Dealer Name',
            extras: 'Extras',
            down_payment: 'Down Payment',
            dealer_discount: 'Dealer Discount',
            wkz: 'WKZ',
            financing_amount: 'Financing Amount',
            financial_support: 'Financial Support',
            plate: 'Plate',
            pvp_brand: 'PVPBRAND',
            pvp_scf: 'PVPSCF',
        },
        enUS: {
            customer_code: 'Customer Code',
            dealer_code: 'Dealer Code',
            customer_name: 'Customer Name',
            customer_type: 'Customer Type',
            financial_company: 'Financial Company',
            rebate_type: 'Rebate Type',
            start_inquiry_date: 'Inquiry Start Date',
            start_order_date: 'Order Start Date',
            vin: 'VIN',
            model: 'Model',
            model_details: 'Model Details',
            inquiry_date: 'Inquiry Date',
            order_date: 'Order Date(Bank)',
            user_name: 'Operator',
            create_time: 'Create Time',
            policy_portfolio_name: 'Policy Portfolio Name',
            upload_files: 'Upload Files',
            remark: 'Remark',
            financial_company_rebate: 'Financial Company Rebate',
            contract_no: 'Contract Number',
            campaign_name: 'Campaign Name',
            campaign_value: 'Campaign Value',
            delivery_date: 'Delivery Date(Bank)',
            related_order: 'Related System Sales Order',
            brand: 'Brand',
            cs_date: 'Contract Start Date',
            activation_date: 'Activation Date',
            contract_status: 'Contract Status',
            product: 'Product',
            product_code: 'Product Code',
            number_of_installments: 'Number of Installments',
            effective_interest_rate: 'Effective Interest Rate',
            nominal_interest_rate: 'Nominal Interest Rate',
            vehicle_price: 'Vehicle Price',
            options: 'Options',
            total_price: 'Total Price',
            OEM_discount_percentage: 'OEM Discount Percentage',
            OEM_discount: 'OEM Discount',
            inquiry_no: 'Inquiry Number',
            dealer_number: 'Dealer Number',
            dealer_name: 'Dealer Name',
            extras: 'Extras',
            down_payment: 'Down Payment',
            dealer_discount: 'Dealer Discount',
            wkz: 'WKZ',
            financing_amount: 'Financing Amount',
            financial_support: 'Financial Support',
            plate: 'Plate',
            pvp_brand: 'PVPBRAND',
            pvp_scf: 'PVPSCF',
        },
    },
    promoFinanceList: {
        zhCN: {
            customer_code: '客户代码',
            dealer_code: '经销商代码',
            customer_name: '客户名称',
            bill_month: 'Bill Month',
            rebate_type: '返利类型',
            finance_status: 'Finance Status',
            matching_status: 'Matching Status',
            pending_status: 'Status',
            financial_company: '金融公司',
            contract_no_d: '合同单号',
            trim_version: '内饰版本',
            error_reason: 'Error Reason',
            pending_reason: 'Pending Reason',
            retry_count: 'Retry Count',
            last_check_time: 'Last Check Time ',
            customer_type: '客户类型',
            start_inquiry_date: '询价开始日期',
            start_order_date: '订单开始日期',
            vin: 'VIN',
            model: '车型',
            model_details: '详细车型',
            inquiry_date: 'Inquiry Date',
            order_date: 'Order Date(Bank)',
            user_name: '操作者',
            create_time: '创建时间',
            policy_portfolio_name: '政策集名称',
            upload_files: '上传文件',
            remark: '备注',
            financial_company_rebate: '金融公司返利',
            contract_no: '合同单号',
            campaign_name: 'Campaign Name',
            campaign_value: 'Campaign Value',
            delivery_date: 'Delivery Date(Bank)',
            related_order: '关联系统销售订单',
            brand: '品牌',
            cs_date: 'Contract Start Date',
            activation_date: 'Activation Date',
            contract_status: 'Contract Status',
            product: 'Product',
            product_code: 'Product Code',
            number_of_installments: 'Number of Installments',
            effective_interest_rate: 'Effective Interest Rate',
            nominal_interest_rate: 'Nominal Interest Rate',
            vehicle_price: 'Vehicle Price',
            options: 'Options',
            total_price: 'Total Price',
            OEM_discount_percentage: 'OEM Discount Percentage',
            OEM_discount: 'OEM Discount',
            inquiry_no: 'Inquiry Number',
            dealer_number: 'Dealer Number',
            dealer_name: 'Dealer Name',
            extras: 'Extras',
            down_payment: 'Down Payment',
            dealer_discount: 'Dealer Discount',
            wkz: 'WKZ',
            financing_amount: 'Financing Amount',
            financial_support: 'Financial Support',
            batch_trans_msg: 'Confirm batch transfer?',
            promofinance_amount: 'Promofinance Amount',
        },
        enUS: {
            customer_code: 'Customer Code',
            dealer_code: 'Dealer Code',
            customer_name: 'Customer Name',
            bill_month: 'Bill Month',
            rebate_type: 'Rebate Type',
            finance_status: 'Finance Status',
            matching_status: 'Matching Status',
            pending_status: 'Status',
            financial_company: 'Financial Company',
            contract_no_d: 'Contract No.',
            vin: 'VIN',
            model: 'Model',
            trim_version: 'Trim Version',
            error_reason: 'Error Reason',
            pending_reason: 'Pending Reason',
            retry_count: 'Retry Count',
            last_check_time: 'Last Check Time ',
            user_name: 'Operator',
            create_time: 'Create Time',
            customer_type: 'Customer Type',
            start_inquiry_date: 'Inquiry Start Date',
            start_order_date: 'Order Start Date',
            model_details: 'Model Details',
            inquiry_date: 'Inquiry Date',
            order_date: 'Order Date(Bank)',
            policy_portfolio_name: 'Policy Portfolio Name',
            upload_files: 'Upload Files',
            remark: 'Remark',
            financial_company_rebate: 'Financial Company Rebate',
            contract_no: 'Contract Number',
            campaign_name: 'Campaign Name',
            campaign_value: 'Campaign Value',
            delivery_date: 'Delivery Date(Bank)',
            related_order: 'Related System Sales Order',
            brand: 'Brand',
            cs_date: 'Contract Start Date',
            activation_date: 'Activation Date',
            contract_status: 'Contract Status',
            product: 'Product',
            product_code: 'Product Code',
            number_of_installments: 'Number of Installments',
            effective_interest_rate: 'Effective Interest Rate',
            nominal_interest_rate: 'Nominal Interest Rate',
            vehicle_price: 'Vehicle Price',
            options: 'Options',
            total_price: 'Total Price',
            OEM_discount_percentage: 'OEM Discount Percentage',
            OEM_discount: 'OEM Discount',
            inquiry_no: 'Inquiry Number',
            dealer_number: 'Dealer Number',
            dealer_name: 'Dealer Name',
            extras: 'Extras',
            down_payment: 'Down Payment',
            dealer_discount: 'Dealer Discount',
            wkz: 'WKZ',
            financing_amount: 'Financing Amount',
            financial_support: 'Financial Support',
            batch_trans_msg: 'Confirm batch transfer?',
            promofinance_amount: 'Promofinance Amount',
        },
    },
    b2bPriceTerm: {
        zhCN: {
            b2b_code: 'B2B Code',
            parameter_code: '参数号',
            parameter_name: '参数名称',
            status: 'Status',
            order_type: 'Order Type',
            start_date: 'Start Date',
            end_date: 'End Date',
            operator: 'Operator',
            update_time: '更新时间',
            create_time: '创建时间',
            action: '操作',
            effective_period: 'Effective Period',
            dealer_code: 'Dealer Code',
            save_as_draft: 'Save as Draft',
            add_by: 'Add By',
            new_item: 'New Item',

            parameter_type: '参数类型',
            parameter_table: '表格',
            parent_parameter: '父参数',
            previous_parameter: 'Previous Parameter',
            next_parameter: '子参数',
            related_parameter: 'Related Parameter',
            module_name: '模块名称',
            column_sort: '列排序',
            date_type: '日期类型',
            copy: '复制',
            trim_version: 'Trim Version',
            model: '车型',
            term: 'Term',
            origin_special_parameter: 'Origin Special Parameter',
            sp_tip: '导入数据与当前数据存在重复数据',
            sp_copy_tip: '原有数据与当前数据存在重复数据',
            uploaded_by: '上传值',
            parameter_name_level: '关联奖励等级',
            financial_type: '财务类型',
        },
        enUS: {
            b2b_code: 'B2B Code',
            parameter_code: 'Parameter Code',
            parameter_name: 'Parameter Name',
            status: 'Status',
            order_type: 'Order Type',
            start_date: 'Start Date',
            end_date: 'End Date',
            operator: 'Operator',
            update_time: 'Update Time',
            create_time: 'Create Time',
            action: 'Action',
            effective_period: 'Effective Period',
            dealer_code: 'Dealer Code',
            save_as_draft: 'Save as Draft',
            add_by: 'Add By',
            new_item: 'New Item',

            parameter_type: 'Parameter Type',
            parent_parameter: 'Parent Parameter',
            previous_parameter: 'Previous Parameter',
            next_parameter: 'Next Parameter',
            related_parameter: 'Related Parameter',
            module_name: 'Module Name',
            parameter_table: 'Table',
            column_sort: 'Column Sort',
            date_type: 'Date Type',
            copy: 'Copy',
            trim_version: 'Trim Version',
            model: 'Model',
            term: 'Term',
            origin_special_parameter: 'Origin Special Parameter',
            sp_tip: 'There is duplicate data between the imported data and the current data.',
            sp_copy_tip: 'There is duplicate data between the origin data and the current data.',
            uploaded_by: 'Uploaded By',
            parameter_name_level: 'Related bonus level',
            financial_type: 'Financial Type',
        },
    },
};
